import React, { useState, useEffect } from 'react';
import SpeechBubble from '../MainDropDown/SpeechBubble.svg';
import Audio from './Audio.svg'


const ExpandableBox = props => {
    const [expand, setExpand] = useState(false)

    function switchExpand() {
        setExpand(!expand)
    }
    return (
        <div className={`${props.display ? `ExpandableBox` : `hide`} ${expand&& "display"}`} onClick={switchExpand}> 
            <div className={`top-section ${props.checked&& "checked"} `}>
                <div className={`button-container`}>
                    <div className={`expand-toggle`} >{expand ? "-" : "+"}</div>
                </div>
                <div className={`capability-and-message`}>
                    <div className={`capability-second-checkbox-container`}>
                        <h3>{props.data.header}</h3>
                        {props.checked &&
                            <div className="check-container dropdown-check">
                                <input className={`secondary-checkbox`} type="checkbox" checked={true} />
                                <span className="checkmark"></span>
                            </div>
                        }
                    </div>
                    <div>
                        {/* <button onClick={() => props.setCurrentItemInfo([props.parentIndex, props.index])} className={`message-icon`}><img src={SpeechBubble} alt="Speech Bubble"/></button> */}
                    </div>
                </div>
            </div>
            <div className={expand ? `bottom-section` : `hide`}>
                <p className={`text`}>{props.data.note}</p>
                <div>
                    {/* <button className={`speaker-icon`} onClick={props.showAudio}><img src={Audio} alt="Audio Button" /></button> */}
                </div>
                
            </div>
        </div>
    )
}

export default ExpandableBox